.list {
  display: grid;
  gap: 12px;
}

.item {
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  background: var(--color-bg-card);
  overflow: hidden;
}

.trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  padding: 18px 20px;
  border: none;
  background: transparent;
  color: var(--color-text);
  font-size: 15px;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
}

.trigger:hover {
  background: rgba(255, 255, 255, 0.03);
}

.chevron {
  flex-shrink: 0;
  font-size: 20px;
  font-weight: 400;
  color: var(--color-gold);
}

.panel {
  padding: 0 20px 18px;
}

.panel p {
  font-size: 14px;
  line-height: 1.65;
  color: var(--color-text-muted);
}
